// extracted by mini-css-extract-plugin
export default {"ragIndicator":"RagIndicatorRisk_ragIndicator__CKikF","indicator":"RagIndicatorRisk_indicator__cxsWL"};